import Vue from 'vue';
import LineChart from '@/components/v2/LineChart';
import '@/assets/stylesheets/utils/helpers/_typography.scss';
import '@/assets/stylesheets/v2/_graph-container.scss';
export default Vue.extend({
    props: {
        header: {
            type: String,
            default: '',
        },
        height: {
            type: Number,
            default: 347,
        },
        labels: {
            type: Array,
            default: () => [],
        },
        data: {
            type: Array,
            default: () => [],
        },
        elementBackgroundColor: {
            type: String,
            default: 'rgba(0, 164, 184, 0.6)',
        },
    },
    computed: {
        canvasHeight() {
            return `${this.height}px`;
        },
    },
    render(createElement) {
        return createElement('v-card', {
            class: 'pa-2',
        }, [
            createElement('v-card-title', {
                class: 'card-title',
            }, this.header),
            createElement('div', {
                class: 'graph-container ma-3',
            }, [
                createElement(LineChart, {
                    style: {
                        height: this.canvasHeight,
                    },
                    props: {
                        labels: this.labels,
                        data: this.data,
                        elementBackgroundColor: this.elementBackgroundColor,
                    },
                }),
            ]),
        ]);
    },
});
